import React, { FC } from 'react';
import { Route } from 'react-router';

import EquipmentsTable from '../components/equipments/table';
import { TransactionsTable } from './equipments/transactions/table';
import EquipmentsLocationTable from './equipments/locations/table';
import { EquipmentsImportPage } from './equipments/imports';
import PaidInstallationsTable from './equipments/paid-installations/table';

const EquipmentsPage: FC = () => {
  return (
    <>
      <Route exact path="/equipments/transactions" component={TransactionsTable} />
      <Route exact path="/equipments/locations" component={EquipmentsLocationTable} />
      <Route exact path="/equipments/imports" component={EquipmentsImportPage} />
      <Route exact path="/equipments/paid-installations" component={PaidInstallationsTable} />
      <Route exact path="/equipments/" component={EquipmentsTable} />
    </>
  );
};

export default EquipmentsPage;
